import { useEffect } from "react";
import "./allowSticky.css";

const CLASS_NAME = "allow-sticky";

// Ref-counted so two components on the same page can both ask for it without
// the first to unmount switching it off for the other.
let users = 0;

/**
 * Lets `position: sticky` work inside the site shell for as long as the calling
 * component is mounted. See allowSticky.css for why this is needed.
 */
export default function useAllowSticky() {
  useEffect(() => {
    users += 1;
    document.documentElement.classList.add(CLASS_NAME);

    return () => {
      users -= 1;
      if (users <= 0) {
        users = 0;
        document.documentElement.classList.remove(CLASS_NAME);
      }
    };
  }, []);
}
